import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "foot-container"
};
import { ref } from "vue";
import { httpGet } from "@/utils/http";
import { showMessageError } from "@/utils/dialog";
import { getLicenseInfo, getSystemInfo } from "@/store/cache";
export default {
  __name: 'FooterBar',
  props: {
    textColor: {
      type: String,
      default: "#ffffff"
    }
  },
  setup(__props) {
    const title = ref("");
    const version = ref(process.env.VUE_APP_VERSION);
    const gitURL = ref(process.env.VUE_APP_GIT_URL);
    const copyRight = ref("");
    const license = ref({});
    const props = __props;

    // 获取系统配置
    getSystemInfo().then(res => {
      title.value = res.data.title ?? process.env.VUE_APP_TITLE;
      copyRight.value = res.data.copyright.length > 1 ? res.data.copyright : "知派科技 © 2025 - " + new Date().getFullYear() + " All rights reserved.";
    }).catch(e => {
      showMessageError("获取系统配置失败：" + e.message);
    });
    getLicenseInfo().then(res => {
      license.value = res.data;
    }).catch(e => {
      showMessageError("获取 License 失败：" + e.message);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "footer"
      }, [_createElementVNode("div", null, [_createElementVNode("span", {
        class: "mr-[10px]"
      }, "知派乐和"), _createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank",
        style: {
          "color": "inherit"
        }
      }, "鄂ICP备2025100242号-2")])], -1)]));
    };
  }
};